import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { ResponseSchema } from "../response/PropertyResponse";

export const useGetMyPropertyQuery = () => {
    return useQuery({
        queryKey: ['property', 'profile', 'my'],
        queryFn: async () => {
            try {
                const response = await privateApi.get('/v3/my-property');

                console.log('response', response);

                const validationResult = ResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid property data format");
                }
                return validationResult.data;

            } catch (error) {
                console.error('Failed to fetch property', error);
                throw error;
            }
        },
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};